export { 
  FormContainer as Container, 
  FormLabel as Label, 
  FormError as ErrorText 
} from '../../sharedFormStyles';



// WEBPACK FOOTER //
// ./src/design-system/atoms/AutoCompleteSelect/components/AutoCompleteStyles.js